export default __webpack_public_path__ + "static/media/quizic.038d7715.png";